import makeStyles from '@mui/styles/makeStyles';

type Props = {
    isExpanded?: boolean;
    canExpand?: boolean;
    isMobile?: boolean;
};

export const useTextFieldStyles = makeStyles(
    (theme) => ({
        root: (props: Props) => ({
            flex: props.isExpanded ? 1 : 'unset',
            // When the screen reaches md size the general header changes to mobile view, and shows a search box at the top, this is when we need to remove the guest banner search box to have only one search box visible
            [theme.breakpoints.down('md')]: {
                display: props.isMobile ? 'block' : 'none'
            }
        }),
        input: (props: Props) => ({
            padding: 10,
            display: props.isExpanded ? 'block' : 'none',

            '&::placeholder': {
                textOverflow: 'ellipsis !important',
                fontSize: 14,
                lineHeight: 20 / 14,
                fontWeight: 400,
                fontFamily: 'Roboto',
                color: theme.palette.primary['500']
            },
            '&:not(:focus)': {
                '&::placeholder': {
                    visibility: 'unset'
                }
            }
        }),
        notchedOutline: (props: Props) => ({
            ...theme.border({ width: 0, radius: theme.spacing(3) }),
            boxShadow: props.canExpand ? 'none' : `0px 1px 6px 0px ${theme.palette.body.light}`
        }),
        startAdornment: {
            pointerEvents: 'none',
            [theme.breakpoints.up('md')]: {
                margin: theme.spacing(0.5),
                borderRadius: '50%',
                background: 'white'
            }
        },
        startIcon: {
            color: theme.palette.primary.main
        },
        closeIcon: {
            color: '#14142B'
        },
        inputBaseRoot: (props: Props) => ({
            height: 48,
            width: props.isExpanded ? '100%' : 48,
            padding: theme.spacing(1),
            borderRadius: '24px',
            backgroundColor: props.canExpand ? theme.palette.common.white : 'none',

            '& .MuiInputAdornment-positionEnd': {
                width: props.canExpand && props.isExpanded ? 24 : 'unset',
                display: props.isExpanded ? 'flex' : 'none'
            },

            '&.Mui-disabled': {
                color: theme.palette.titleActive.main,
                pointerEvents: 'none',
                background: theme.palette.background.default,

                '& $notchedOutline': {
                    borderColor: '#F5F5F5'
                }
            },
            '&:active': {
                backgroundColor: theme.palette.common.white
            },
            '&:hover': {
                '& $notchedOutline': {
                    borderColor: '#F5F5F5'
                }
            },

            '&.Mui-focused': {
                backgroundColor: theme.palette.common.white,

                '& $notchedOutline': {
                    borderColor: '#F5F5F5',
                    borderWidth: 1
                }
            },

            '&.Mui-error': {
                '&, &:hover, &.Mui-focused': {
                    '& $notchedOutline': {
                        borderColor: '#F5F5F5'
                    }
                }
            },
            [theme.breakpoints.up('md')]: {
                maxWidth: 600,
                width: '100%'
            }
        })
    }),
    // to have more priority over TextField styles
    { name: 'SearchBox', index: 10 }
);

const useStyles = () => ({});

export default useStyles;
